import React, { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { push as Menu } from "react-burger-menu";
import { Link, NavLink, Redirect } from "react-router-dom";
import { PowerSettingsNew, Search } from "@material-ui/icons";
import Cookies from "js-cookie";
import { getInfo, Role } from "../../utils/hooks";
import UserContext from "../../context/UserContext";
import logo from "../../icons/logo.jpg";
import config from "../../config/apiConfig";
import ReactGA from "react-ga";

const CriticNav: React.FC = () => {
    //@ts-ignore
    const [user, setUser] = useContext(UserContext);
    const [loggedIn, setLoggedIn] = useState(true);
    const [query, setQuery] = useState("");
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

    useEffect(() => {
        if (Cookies.get("token") === undefined) {
            setLoggedIn(false);
        }
    }, []);

    function handleLogout() {
        Cookies.remove("token");
        Cookies.remove("id");
        Cookies.remove("info");
        Cookies.remove("current_filter");
        Cookies.remove("admin");
        Cookies.remove("auth_token");
        window.location.replace(
            "http://13.235.209.150/auth?token=&redirect_url=http://13.235.209.150/login&gr=logout"
        );
    }

    function handleDrop(e: any) {
        document.getElementById(e.target.name)?.classList.toggle("dshow");
    }

    function handleSearch() {
        if (query != "") {
            console.log("query", query);
            const win = window.open("/writer/search?query=" + query, "_self");
        }
    }

    const handleRoleChange = (role: Role) => {
        if (!role.approved) {
            alert("Your application is being reviewed. Please wait for your approval.");
            return;
        }
        if (role.name === "pencil_writer") {
            window.location.replace(
                `http://13.235.209.150/auth?token=${Cookies.get(
                    "auth_token"
                )}&redirect_url=http://13.235.209.150/dashboard&gr=pencil_writer`
            );
        }
        const formData = new FormData();
        formData.append("auth_token", Cookies.get("auth_token") ?? "");
        formData.append("gr", role.name);
        formData.append("token", config.token);
        formData.append("session-token", "AUTH");
        formData.append("device", "web");
        formData.append("user_ip", "120.12.22.130");
        formData.append("user_agent", "Mozilla 1");
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/idam/user/sso_login", requestOptions)
            .then((response) => response.json())
            .then((resp) => {
                if (resp.is_error) {
                    return;
                } else {
                    Cookies.set("info", JSON.stringify(resp.data.user_info));
                    ReactGA.event({
                        category: "AUTH",
                        action: "Dashboard changed to " + role.label,
                        label: resp.data.user_id,
                    });
                    window.location.reload();
                }
            });
    };

    return loggedIn ? (
        isTabletOrMobile ? (
            <Menu pageWrapId={"main"} outerContainerId={"outer-container"}>
                <div className="navbar__left" style={{ display: "flex" }}>
                    <Link to="/critic">
                        <img style={{ height: 32 }} src={logo} alt="" />
                    </Link>
                </div>
                <a
                    className="navbar__link__active"
                    style={{ margin: "40px 0" }}
                >
                    Discover
                </a>
                <a className="navbar__link" style={{ margin: "40px 0" }}>
                    Feedback provided
                </a>
            </Menu>
        ) : (
            <div className="navbar">
                <div className="navbar__left">
                    <Link to="/critic">
                        <img style={{ height: 32 }} src={logo} alt="" />
                    </Link>
                    <div className="navbar__links">
                        <NavLink
                            to="/critic"
                            className="navbar__link"
                            activeClassName="active"
                        >
                            Discover
                        </NavLink>
                        <NavLink
                            to="/critic/dashboard"
                            className="navbar__link"
                            activeClassName="active"
                        >
                            Dashboard
                        </NavLink>
                    </div>
                </div>
                <div className="navbar__right navbar__right__main">
                    <input
                        type="text"
                        className="navbar__input"
                        placeholder={"Search"}
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <Search onClick={() => handleSearch()} />
                    <input type="submit" style={{ display: "none" }}></input>
                    <div className="navbar__profile">
                        <div className="dropdown">
                            <button
                                onClick={(e) => handleDrop(e)}
                                className="navbar__img"
                                name="dprofile"
                            ></button>
                            <div
                                className="dropdown-wrapper pt_0"
                                id="dprofile"
                            >
                                <div className="dropdown-content">
                                    <ul>
                                        {getInfo()?.roles?.map((role) => (
                                            <li
                                                key={role.global_role_id}
                                                onClick={() =>
                                                    handleRoleChange(role)
                                                }
                                                className="write"
                                            >
                                                {role.label} Dashboard
                                            </li>
                                        ))}
                                        <li
                                            className="write"
                                            onClick={() => handleLogout()}
                                        >
                                            <PowerSettingsNew
                                                style={{
                                                    height: "18px",
                                                    width: "18px",
                                                }}
                                            />
                                            <span style={{ paddingLeft: 4 }}>
                                                Log Out
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <h2 className="small__heading">
                            {getInfo()?.name ?? "User"}
                        </h2>
                    </div>
                </div>
            </div>
        )
    ) : (
        <Redirect to="/login" />
    );
};

export default CriticNav;
